import { BaseDevice, CustomLayout } from '../../base_device'
import { generateArray } from '@/tool/utility'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import list_icon from '@/assets/img/device/nd75/list_icon.png'
import { nd75VKCodes } from '../keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST } from '../../light/light_effect_list'

export class ND75 extends BaseDevice {
  minDelayTimer: number = 1
  maxDelayTimer: number = 60000

  speedAllowValues: number[] = generateArray(0, 5)
  lightAllowValues: number[] = generateArray(0, 5)
  magneticAxis: boolean = true
  name: string = 'ND75'
  icon: string = list_icon
  width: number = 770
  square = getDeviceKeySquare(DevicePid.IROKNd75)
  resetDes: string = 'recovery_notice_nd75'
  y_number: number = 10
  inoperableKeys: KK[] = [0x50a]
  fnDisableKeys: KK[] = [0x0002, 0x0003, 0x0004, 0x0005, 0x0007, 0x0008, 0x0009, 0x000a, 0x000b, 0x000c, 0x000d, 0x000e, 0x000f, 0x010a, 0x010b, 0x010c, 0x010f, 0x0209, 0x020a, 0x020f, 0x030f, 0x0402, 0x0403, 0x0404, 0x0405, 0x0501, 0x050a]
  vkcodes = nd75VKCodes
  absoluteKey: CustomLayout = {
    0x40e: this.createSquare(661, 4),
    0x50d: this.createSquare(615, 4),
    0x50e: this.createSquare(661, 4),
    0x50f: this.createSquare(707, 4),
  }

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST

  customLayout: CustomLayout = {
    0x2: this.createSquare(47, 2),
    0x7: this.createSquare(18, 2),
    0xb: this.createSquare(18, 2),
    0xf: this.createSquare(13, 2),
    0x100: this.createSquare(2, this.y_number),
    0x101: this.createSquare(2, this.y_number),
    0x102: this.createSquare(2, this.y_number),
    0x103: this.createSquare(2, this.y_number),
    0x104: this.createSquare(2, this.y_number),
    0x105: this.createSquare(2, this.y_number),
    0x106: this.createSquare(2, this.y_number),
    0x107: this.createSquare(2, this.y_number),
    0x108: this.createSquare(2, this.y_number),
    0x109: this.createSquare(2, this.y_number),
    0x10a: this.createSquare(2, this.y_number),
    0x10b: this.createSquare(2, this.y_number),
    0x10c: this.createSquare(2, this.y_number),
    0x10e: this.createSquare(2, this.y_number, 75),
    0x10f: this.createSquare(13, this.y_number),
    0x200: this.createSquare(2, 2, 56),
    0x20e: this.createSquare(2, 2, 64),
    0x20f: this.createSquare(13, 2),
    0x300: this.createSquare(2, 2, 68),
    0x30e: this.createSquare(2, 2, 98),
    0x30f: this.createSquare(13, 2),
    0x400: this.createSquare(2, 2, 88),
    0x40c: this.createSquare(2, 2, 81),
    0x500: this.createSquare(2, 2, 56),
    0x501: this.createSquare(2, 2, 56),
    0x502: this.createSquare(2, 2, 56),
    0x506: this.createSquare(2, 2, 243),
    0x509: this.createSquare(2, 2, 56),
    0x50a: this.createSquare(2, 2, 56),
    0x50c: this.createSquare(2, 2, 56),
    0x50d: this.createSquare(4, 2),
  }
  // win按键锁定
  lockWin: boolean = true
  // 回报率
  rate: number[] = [1, 2, 4, 8]
}
